module.exports = __webpack_public_path__ + "img/pdf-image-placeholder.c09e9fb0.png";